export enum DiagnosticReportCode {
  ampath = 'diagnosticreport.pathology.ampath',
  lancet = 'diagnosticreport.pathology.lancet',
}

// TODO this should be moved to the generic identifiers list
export enum DiagnosticReportIdentifier {
  AmpathOrderNumber = 'diagnosticreport.identifier.ampath.ordernumber',
  LancetOrderNumber = 'diagnosticreport.identifier.lancet.ordernumber',
  LancetOrderId = 'diagnosticreport.identifier.lancet.orderId',
}
